export enum CapabilityKind {
  None = 0,
  Info = 1,
  Order = 2,
  InfoAndOrder = Info | Order,
  BulkOrder = 4,
  InfoAndOrderAndBulkOrder = Info | Order | BulkOrder,
  DeliveryNotes = 8,
  Invoices = 16,
  Articles = 32
}
